module.exports = __webpack_public_path__ + "static/media/pampafly.88f12991.webp";